/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeople200,
  PostApiV1IndividualpaymentFinancialPeople400,
  PostApiV1IndividualpaymentFinancialPeople401,
  PostApiV1IndividualpaymentFinancialPeople500,
  PostApiV1IndividualpaymentFinancialPeopleMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeople.ts";
import { individualPaymentSaveViewModelSchema } from "../individualPaymentSaveViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeople200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeople200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentFinancialPeople400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeople400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeople401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeople500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeople500>;

export const postApiV1IndividualpaymentFinancialPeopleMutationRequestSchema =
  z.lazy(
    () => individualPaymentSaveViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleMutationRequest>;

export const postApiV1IndividualpaymentFinancialPeopleMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentFinancialPeople200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleMutationResponse>;
